document.addEventListener('DOMContentLoaded', () => {
  const offers = document.querySelectorAll('.Offer__single');

  offers.forEach((offer) => {
    const desc = offer.querySelector('.Offer__desc');

    desc.addEventListener('click', () => {
      // Jeśli ten już aktywny — usuń i zakończ
      if (offer.classList.contains('active')) {
        offer.classList.remove('active');
        return;
      }


      // Dodaj active do klikniętego
      offer.classList.add('active');
    });
  });
});
